<template>
  <div class="my-3">
    <label>Edit Active Programs</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
        <label>Prgrams or Contests for {{ clientData.text }}</label>
        <b-table class="table table-responsive table-bordered mt-3" responsive="sm" :fields="Fields" :items="Items">
          <template v-slot:cell(select)="data">
            <b-form-checkbox v-model="ProgramOrContestIds" :value="data.item.select"> </b-form-checkbox>
          </template>
          <template v-slot:cell(program_name)="data">
            <div style="display: flex">
              <router-link
                :to="{
                  name: 'AdminPointProgramsEditProgramContest',
                  params: { programId: data.item.program_id },
                }"
                @click.native="scrollToTop"
                class="my-1"
                >{{ data.item.program_name }}</router-link
              >
              <p v-if="data.item.active === false" class="my-1">
                &nbsp;(in-active program/contest)
              </p>
            </div>
          </template>
          <template v-slot:cell(default_points)="data">
            <span v-if="data.item.default_points < 0" class="badge badge-danger">{{
              data.item.default_points
                ? parseInt(data.item.default_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                : '0.00'
            }}</span>
            <span v-else-if="data.item.default_points >= 0" class="badge badge-success">{{
              data.item.default_points
                ? parseInt(data.item.default_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                : '0.00'
            }}</span>
          </template>
        </b-table>
        <form v-on:submit.prevent="updateProgramOrContestList()">
          <input
            class="btn btn-primary btn-lg btn-sm-block mr-2 my-2"
            type="submit"
            name="update"
            value="Update Program/contest List"
            :disabled="!ProgramOrContestIds.length"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointProgramEditActivePrograms.vue',

  props: {
    clientData: Object,
  },

  data() {
    return {
      Fields: [
        {
          key: 'program_id',
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'select',
          thStyle: { width: '10%' },
        },
        {
          key: 'program_name',
        },
        {
          key: 'default_points',
          thStyle: { width: '20%', textAlign: 'right' },
          tdClass: 'text-right',
        },
      ],
      Items: [],
      ProgramOrContestIds: [],
    };
  },

  computed: {
    getAllClientPrograms() {
      return this.$store.getters['adminPointPrograms/getAllClientPrograms'];
    },
  },

  watch: {
    getAllClientPrograms(getAllClientPrograms) {
      var datas = getAllClientPrograms.map(function(data) {
        return {
          program_id: data.programId,
          select: data.programId,
          program_name: data.programName,
          default_points: data.presetPoints,
          active: data.active,
        };
      });

      this.Items = datas;

      var new_datas = getAllClientPrograms.map(function(data) {
        return data.isProgramActiveForSelectedClient === true ? data.programId : null;
      });

      this.ProgramOrContestIds = new_datas;
    },
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    updateProgramOrContestList() {
      const params = {
        clientId: this.clientData.value,
        programIds: this.ProgramOrContestIds,
      };

      this.$store
        .dispatch('adminPointPrograms/updateAllProgramOrContest', params)
        .then((status) => {
          if (status) {
            // update all clients program store
            this.$store.dispatch('adminPointPrograms/fetchAllProgramsByClient', {
              clientId: this.clientData.value,
            });

            // updating latest program list in store
            this.$store.dispatch('adminPointPrograms/fetchProgrammes', {
              clientId: 0,
            });

            this.scrollToTop();
          }
        })
        .catch(() => {
          console.log('error from all edit program and contest');
        });
    },
  },

  created() {
    this.$store.dispatch('adminPointPrograms/fetchAllProgramsByClient', {
      clientId: this.clientData.value,
    });
  },
};
</script>

<style></style>
